const domain = require('getdomain')
import { getOutlet } from '@/api/outlet'
import { hintStore } from '@/api/global'

const selectedBranch = localStorage.getItem(`${process.env.VUE_APP_COOKIE_KEY}_selected_branch`)

const outlet = {
  state: {
    url_domain: '',
    store_id: '',
    main_store: {},
    selected_outlet: {},
    selected_branch: selectedBranch ? JSON.parse(selectedBranch) : {}
  },

  mutations: {
    SET_OUTLET: (state, val) => {
      state.selected_outlet = val
    },
    SET_MAIN_STORE: (state, val) => {
      state.main_store = val
    },
    SET_URL_DOMAIN(state, data) {
      state.url_domain = data
      localStorage.setItem(process.env.VUE_APP_COOKIE_KEY + '_url_domain', data)
    },
    SET_STORE_ID(state, data) {
      state.store_id = data
      localStorage.setItem(process.env.VUE_APP_COOKIE_KEY + '_store_id', data)
    },
    SET_SELECTED_BRANCH(state, data) {
      state.selected_branch = data
      localStorage.setItem(
        `${process.env.VUE_APP_COOKIE_KEY}_selected_branch`,
        JSON.stringify(data)
      )
    }
  },

  getters: {
    selectedOutlet: state => state.selected_outlet,
    mainStore: state => state.main_store,
    selectedBranch: state => state.selected_branch
  },

  actions: {
    async checkDomain({ commit, state }) {
      const url_domain = localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_url_domain')
      try {
        // kalau sudah ada domain tersimpan, anggap valid
        if (url_domain && url_domain !== '') {
          return true
        }

        // development mode pakai domain dummy
        if (process.env.NODE_ENV === 'development') {
          commit('SET_URL_DOMAIN', 'ptkoneksipintarnusantarauntukekosistemcerdas')
          commit('SET_STORE_ID', Number(303075))
          return true
        }

        // ambil domain dan hostname saat ini
        const curr_domain = domain.get(window.location.href)
        let hostname = domain.hostname(window.location.href)

        // handle kalau di localhost (testing lokal)
        if (hostname === 'localhost') {
          hostname = 'ptkoneksipintarnusantarauntukekosistemcerdas.antarinbarang.com'
        }

        // kalau domain utama (indociti.com)
        if (curr_domain === 'indociti.com') {
          const fallbackHost = 'ptkoneksipintarnusantarauntukekosistemcerdas.antarinbarang.com'
          const form = { domain: fallbackHost }

          const { data } = await hintStore(form)
          commit('SET_URL_DOMAIN', data.data.url_id)
          commit('SET_STORE_ID', data.data.store_id)
          return true
        }

        // kalau domain custom (selain indociti.com)
        if (curr_domain !== 'indociti.com') {
          const form = { domain: hostname }

          const { data } = await hintStore(form)
          commit('SET_URL_DOMAIN', data.data.url_id)
          commit('SET_STORE_ID', data.data.store_id)
          return true
        }

        // fallback terakhir: ambil subdomain manual
        const subdomain = window.location.host.split('.')[1]
          ? window.location.host.split('.')[0]
          : false

        if (subdomain) {
          commit('SET_URL_DOMAIN', subdomain)
          return true
        }

        // kalau semua gagal
        commit('SET_URL_DOMAIN', '')
        commit('SET_STORE_ID', '')
        return false
      } catch (e) {
        commit('SET_URL_DOMAIN', '')
        commit('SET_STORE_ID', '')
        return false
      }
    },
    async fetchOutlet({ commit, state }, { params, isSetMainStore = false }) {
      try {
        const { data } = await getOutlet(params)
        if (isSetMainStore) {
          commit('SET_MAIN_STORE', data.data)
        } else {
          commit('SET_OUTLET', data.data)
        }
      } catch (e) {
        if (isSetMainStore) {
          commit('SET_MAIN_STORE', {})
        } else {
          commit('SET_OUTLET', {})
        }
      }
    }
  }
}

export default outlet
